import { render } from "./DetailsHospitalisation.vue?vue&type=template&id=1f616f4d&scoped=true"
import script from "./DetailsHospitalisation.vue?vue&type=script&lang=js"
export * from "./DetailsHospitalisation.vue?vue&type=script&lang=js"

import "./DetailsHospitalisation.vue?vue&type=style&index=0&id=1f616f4d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f616f4d"]])

export default __exports__